import React from "react";
import { EmptyState } from "@/components/portal/PortalBits";

function statusColor(s) {
  if (s === "quoted" || s === "contacted") return "text-primary-brand";
  if (s === "closed") return "text-slate-400";
  return "text-slate-700";
}

export function QuotesList({ quotes }) {
  if (quotes.length === 0) {
    return <EmptyState label="No quote requests yet." />;
  }
  return (
    <div className="border border-slate-200 bg-white overflow-x-auto" data-testid="my-quotes-panel">
      <table className="w-full min-w-[720px] text-sm">
        <thead>
          <tr className="text-left text-[10px] uppercase tracking-[0.2em] text-slate-500 border-b border-slate-200">
            <th className="px-4 py-3">Submitted</th>
            <th className="px-4 py-3">Route</th>
            <th className="px-4 py-3">Service</th>
            <th className="px-4 py-3">Cargo</th>
            <th className="px-4 py-3">Status</th>
          </tr>
        </thead>
        <tbody>
          {quotes.map((q) => (
            <tr key={q.id} className="border-b border-slate-100 hover:bg-slate-50" data-testid={`my-quote-${q.id}`}>
              <td className="px-4 py-4 text-slate-500 text-xs">{new Date(q.created_at).toLocaleDateString()}</td>
              <td className="px-4 py-4 text-slate-700">
                <div>{q.pickup_location}</div>
                <div className="text-slate-500 text-xs">→ {q.dropoff_location}</div>
              </td>
              <td className="px-4 py-4 text-slate-700 text-xs">{q.service_type}</td>
              <td className="px-4 py-4 text-slate-500 text-xs">{q.cargo_type || "—"} {q.weight ? `· ${q.weight}` : ""}</td>
              <td className="px-4 py-4">
                <span className={`text-xs uppercase tracking-[0.2em] font-bold ${statusColor(q.status)}`}>{q.status}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
